export default "__VITE_ASSET__OhRdIiZr__"